import { useNavigate } from "react-router-dom";


export default function InqueritoCard({ ano, preenchido = false, uuid }) {
    console.log(uuid);
    const navigate = useNavigate();
    const preecherHandler = () => {
        if (preenchido) {
            navigate(`/inquerito/${uuid}`);
        } else {
            navigate('/inquerito');
        }
    }

    return (
        <div className="border border-black-700 p-2 flex flex-row justify-between items-center">
            <p className="font-semibold text-lg mt-2">Avaliação do ano {ano}</p>
            <button className="mt-2 px-3 py-2 bg-green-700 hover:bg-green-600 cursor-pointer text-white text-sm" onClick={preecherHandler}>
                {preenchido ? "Visualizar" : "Preencher"}
            </button>
        </div>
    );
}